let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1lzC1")).then(() => parcelRequire('3QQb6'));